// extraCards.js – Extrakarten (Spielideen) und Regeln, wie freie Plätze in der Schachtel aufgefüllt werden.
// Inhalt der Karten: Text in [eckigen Klammern] wird violett hervorgehoben.

export const EXTRA_PURPLE = '#662d91';

export const KATEGORIEN = [
  'Spielen & Rätseln',
  'Erzählen & Austauschen',
  'Familie entdecken',
  'Gestalten & Verwenden',
];

const AUCH = 'Auch ohne abgebildete Personen spielbar';
const NUR = 'Nur mit den abgebildeten Personen spielbar';

// body-Einträge:
//   { n: 1, text }   nummerierter Schritt (schwarz)
//   { zb: true }     „z. B.:“ (violett)
//   { b: text }      Aufzählungspunkt (violett)
//   { p: text }      Absatz (schwarz, [..] violett)
//   { v: text }      Absatz ganz violett
//   { gap: true }    Leerzeile
export const EXTRA_CARDS = [
  {
    nr: 1, key: 'legende', kategorie: null, titel: 'Legende',
    untertitel: ['Farben und Symbole verstehen'], center: true,
    body: [
      { p: '[Rahmenfarben] zeigen, zu welchem Familienzweig eine Person gehört.' },
      { gap: true },
      { p: '[Symbole am unteren Bildrand] zeigen, wer die Eltern einer Person sind und welche Personen ein Paar sind oder waren.' },
      { gap: true },
      { p: '[Frühere Partner] wurden aufgenommen, sofern es Nachkommen aus dieser Partnerschaft gab.' },
    ],
  },
  {
    nr: 2, key: 'erweiterung', kategorie: null, titel: 'Erweiterung',
    untertitel: ['ergänzt euer Set'], center: true,
    body: [
      { p: 'Noch mehr Familie entdecken!' },
      { gap: true },
      { p: 'Mit einer Erweiterung lernt ihr auch die Familie des anderen Elternteils kennen.' },
      { gap: true },
      { p: 'Die vertrauten Karten des Kindes und seiner Eltern bilden den Ausgangspunkt. Dazu kommen die neuen Familienmitglieder.' },
    ],
  },
  {
    nr: 3, key: 'bestellung', kategorie: null, titel: 'Bestellung',
    untertitel: ['ein eigenes Set bestellen'], center: true,
    body: [
      { p: 'Wer gehört eigentlich zu euch? Bestellt euer persönliches [«Stammbaum MeMo für kleine Familienforscher»] mit euren Familienfotos.' },
      { gap: true },
      { p: 'Für Fragen und Bestellungen:' },
      { p: 'info@bandeleart.ch' },
    ],
  },

  // ── Spielen & Rätseln ────────────────────────────────────────────────
  {
    nr: 4, key: 'detektive', kategorie: 0, titel: 'Detektive',
    untertitel: ['Spielen & Rätseln · Ab 2 Personen', NUR],
    body: [
      { n: 1, text: 'Zieht je eine Foto-MeMokarte eines anderen anwesenden Familienmitglieds.' },
      { n: 2, text: 'Sucht diese Person.' },
      { n: 3, text: 'Im Anschluss stellt er ihn den anderen vor:' },
      { zb: true },
      { b: 'Wie heisst der Gefundene?' },
      { b: 'Wo lebt er?' },
      { b: 'Worauf freut er sich heute?' },
      { b: 'Was braucht er gerade?' },
    ],
  },
  {
    nr: 5, key: 'memory', kategorie: 0, titel: 'Memory',
    untertitel: ['Spielen & Rätseln · Ab 2 Personen', AUCH],
    body: [
      { n: 1, text: 'Die Foto-MeMokarten und die Text-MeMokarten werden als klassisches Memory gespielt.' },
      { n: 2, text: 'Je jünger das Kind, umso weniger Karten sind im Einsatz.' },
      { n: 3, text: 'Das jüngste Familienmitglied beginnt.' },
    ],
  },
  {
    nr: 6, key: 'familien-bingo', kategorie: 0, titel: 'Familien-Bingo',
    untertitel: ['Spielen & Rätseln · Ab 2 Personen', AUCH],
    body: [
      { n: 1, text: 'Alle gestalten eine eigene kleine Bingo-Vorlage mit Fakten:' },
      { zb: true },
      { b: 'Jemand, der im gleichen Monat Geburtstag hat wie ich.' },
      { b: 'Jemand mit Kindern.' },
      { b: 'Jemand, der dazugeliebt wurde.' },
      { b: 'Dein Cousin oder deine Cousine.' },
      { b: 'Jemand, der älter ist als deine Eltern.' },
      { b: 'Etc.' },
    ],
  },
  {
    nr: 7, key: 'wer-bin-ich', kategorie: 0, titel: 'Wer bin ich?',
    untertitel: ['Spielen & Rätseln · Ab 2 Personen', AUCH],
    body: [
      { n: 1, text: 'Alle Foto-MeMokarten liegen offen auf.' },
      { n: 2, text: 'Eine Person zieht eine Text-MeMokarte, ohne sie selbst anzuschauen. Zeige sie den anderen.' },
      { n: 3, text: 'Versuche herauszufinden, wer du bist.' },
      { zb: true },
      { b: 'Bin ich ein Mann?' },
      { b: 'Habe ich Kinder?' },
      { b: 'Bin ich verheiratet? Etc.' },
      { n: 4, text: 'Ziehe eine neue Karte, wenn du es erraten hast.' },
    ],
  },
  {
    nr: 8, key: 'familienraetsel', kategorie: 0, titel: 'Familienrätsel',
    untertitel: ['Spielen & Rätseln · Ab 2 Personen', AUCH],
    body: [
      { n: 1, text: 'Eine MeMokarte wird verdeckt gezogen.' },
      { n: 2, text: 'Jemand beschreibt die Person, ohne den Namen zu nennen:' },
      { zb: true },
      { b: 'Diese Person ist die Tochter von …' },
      { b: 'Diese Person ist die Mutter von …' },
      { b: 'Diese Person ist mit … verheiratet.' },
      { b: 'Diese Person gehört zum blauen Stamm.' },
      { n: 3, text: 'Die anderen raten, wer gemeint ist.' },
    ],
  },
  {
    nr: 9, key: 'wettrennen', kategorie: 0, titel: 'Wettrennen',
    untertitel: ['Spielen & Rätseln · Ab 2 Personen', AUCH],
    body: [
      { n: 1, text: 'Legt nur die Foto-MeMokarten offen hin.' },
      { n: 2, text: 'Die Text-MeMokarten liegen verdeckt auf einem Stapel.' },
      { n: 3, text: 'Eine Text-MeMokarte wird gezogen und vorgelesen.' },
      { n: 4, text: 'Die Mitspielenden suchen die passende Foto-MeMokarte.' },
      { n: 5, text: 'Wer sie zuerst hat, hat gewonnen.' },
    ],
  },
  {
    nr: 10, key: 'halb-memory', kategorie: 0, titel: 'Halb Memory',
    untertitel: ['Spielen & Rätseln · Ab 1 Person', AUCH],
    body: [
      { n: 1, text: 'Die Text-MeMokarten liegen offen.' },
      { n: 2, text: 'Die Foto-MeMokarten liegen verdeckt.' },
      { n: 3, text: 'Eine Foto-MeMokarte wird aufgedeckt und muss der passenden Text-MeMokarte zugeordnet werden.' },
    ],
  },
  {
    nr: 11, key: 'wer-fehlt', kategorie: 0, titel: 'Wer fehlt?',
    untertitel: ['Spielen & Rätseln · Ab 2 Personen', AUCH],
    body: [
      { n: 1, text: 'Eine kleine Gruppe der MeMokarten wird offen hingelegt.' },
      { n: 2, text: 'Dann schliessen die Mitspielenden die Augen.' },
      { n: 3, text: 'Eine Karte wird weggenommen.' },
      { n: 4, text: 'Die Augen werden wieder geöffnet. Wer fehlt?' },
    ],
  },

  // ── Erzählen & Austauschen ───────────────────────────────────────────
  {
    nr: 12, key: 'wuerfelgeschichten', kategorie: 1, titel: 'Würfelgeschichten',
    untertitel: ['Erzählen & Austauschen · Ab 2 Personen', NUR],
    body: [
      { n: 1, text: 'Zieht eine Foto-MeMokarte einer anwesenden Person.' },
      { n: 2, text: 'Diese würfelt mit zwei Würfeln und bildet daraus ein Alter: Aus 3 und 5 werden 8, 35 oder 53 Jahre.' },
      { n: 3, text: 'Dazu erzählt die Person [z. B.:]' },
      { b: 'Was war damals schön oder schwierig?' },
      { b: 'Wer war ihr Vorbild?' },
      { b: 'Was geschah zu dieser Zeit in der Welt?' },
      { b: 'Auch ein Blick in die Zukunft ist möglich.' },
    ],
  },
  {
    nr: 13, key: 'familiengeschichten', kategorie: 1, titel: 'Familien-\ngeschichten',
    untertitel: ['Erzählen & Austauschen · Ab 2 Personen', AUCH],
    body: [
      { n: 1, text: 'Zieht eine Foto-MeMokarte und haltet sie geheim.' },
      { n: 2, text: 'Erzählt eine kurze Geschichte über die Person, ohne ihren Namen zu nennen. Kennt ihr sie nicht, erfindet eine passende Geschichte.' },
      { n: 3, text: 'Die anderen raten, wer gemeint ist.' },
      { v: 'Andere Variante: Erzählt gemeinsam.' },
    ],
  },
  {
    nr: 14, key: 'gespraechskreis', kategorie: 1, titel: 'Gesprächskreis',
    untertitel: ['Erzählen & Austauschen · Ab 2 Personen', AUCH],
    body: [
      { n: 1, text: 'Zieht jeweils eine Foto-MeMokarte.' },
      { n: 2, text: 'Nacheinander sagt jede Person etwas zum gezogenen Familienmitglied.' },
      { zb: true },
      { b: 'Das weiss ich über diese Person.' },
      { b: 'Das würde ich sie gerne einmal fragen.' },
      { b: 'Das verbindet mich mit ihr.' },
      { b: 'Das habe ich von ihr geerbt oder gelernt.' },
    ],
  },
  {
    nr: 15, key: 'familienfragen', kategorie: 1, titel: 'Familienfragen',
    untertitel: ['Erzählen & Austauschen · Ab 2 Personen', AUCH],
    body: [
      { n: 1, text: 'Eine Karte wird gezogen und dazu eine Frage beantwortet:' },
      { zb: true },
      { b: 'Wer ist diese Person für dich?' },
      { b: 'Was magst du an ihr?' },
      { b: 'Wann hast du sie zuletzt gesehen?' },
      { b: 'Was würdest du gerne mit ihr machen?' },
      { b: 'Was möchtest du sie einmal fragen?' },
    ],
  },
  {
    nr: 16, key: 'komplimente', kategorie: 1, titel: 'Komplimente',
    untertitel: ['Erzählen & Austauschen · Ab 2 Personen', NUR],
    body: [
      { n: 1, text: 'Zieht eine Foto-MeMokarte.' },
      { n: 2, text: 'Jede mitspielende Person sagt einen schönen Satz über die abgebildete Person.' },
      { zb: true },
      { b: 'Ich mag an dir …' },
      { b: 'Ich finde schön, dass du …' },
      { b: 'Ich erinnere mich gerne an …' },
      { b: 'Ich finde, du kannst besonders gut …' },
    ],
  },

  // ── Familie entdecken ────────────────────────────────────────────────
  {
    nr: 17, key: 'zielgruppen', kategorie: 2, titel: 'Zielgruppen',
    untertitel: ['Familie entdecken · Ab 1 Person', AUCH],
    body: [
      { n: 1, text: 'Die Foto-MeMokarten werden nach Zielgruppen sortiert:' },
      { zb: true },
      { b: 'Alle Kinder, alle Opas, alle Frauen, etc.' },
      { b: 'Alle mit zwei Elternhäusern.' },
      { b: 'Alle, die im selben Monat geboren sind.' },
      { b: 'Alle Pädagogen, Musiker, etc.' },
      { b: 'Alle Cousins & Cousinen.' },
      { b: 'Etc.' },
    ],
  },
  {
    nr: 18, key: 'zahlenstrahl', kategorie: 2, titel: 'Zahlenstrahl',
    untertitel: ['Familie entdecken · Ab 1 Person', AUCH],
    body: [
      { n: 1, text: 'Lege die Foto-MeMokarten als Zahlenstrahl.' },
      { n: 2, text: 'Nimm die Text-MeMokarten zur Hilfe.' },
      { zb: true },
      { b: 'Vom ältesten zum jüngsten Familienmitglied gelegt.' },
    ],
  },
  {
    nr: 19, key: 'stammbaum', kategorie: 2, titel: 'Stammbaum',
    untertitel: ['Familie entdecken · Ab 1 Person', AUCH],
    body: [
      { n: 1, text: 'Die Foto-MeMokarten werden zu einem Stammbaum gelegt.' },
      { n: 2, text: 'Beginnt mit den mehrfarbigen Foto-MeMokarten.' },
      { n: 3, text: 'Legt die Karten ihrer Kinder darunter.' },
      { n: 4, text: 'Ergänzt weitere Familienmitglieder und zeigt, wie sie zusammengehören. Das Kind entscheidet, welchen Familienzweig es entdecken möchte.' },
    ],
  },
  {
    nr: 20, key: 'wie-sind-wir-verwandt', kategorie: 2, titel: 'Wie sind wir\nverwandt?',
    untertitel: ['Familie entdecken · Ab 1 Person', AUCH],
    body: [
      { n: 1, text: 'Der jüngste Spieler zieht eine Karte.' },
      { n: 2, text: 'Alle suchen den Verwandtschaftsweg zwischen dem jüngsten Spieler und der abgebildeten Person.' },
      { n: 3, text: 'Alle passenden Foto-MeMokarten werden in eine Reihe gelegt.' },
      { zb: true },
      { v: 'Ich → Mutter → Grossvater → Onkel' },
    ],
  },
  {
    nr: 21, key: 'generationenleiter', kategorie: 2, titel: 'Generationenleiter',
    untertitel: ['Familie entdecken · Ab 1 Person', AUCH],
    body: [
      { n: 1, text: 'Die MeMo-Karten werden nach Generationen sortiert:' },
      { n: 2, text: 'Kinder, Eltern, Grosseltern, Urgrosseltern.' },
      { n: 3, text: 'Danach wird geforscht.' },
      { zb: true },
      { b: 'Welche Generation ist am grössten?' },
      { b: 'Wer gehört zur gleichen Generation?' },
      { b: 'Wer ist zwar gleich alt, aber in einer anderen Generation?' },
    ],
  },
  {
    nr: 22, key: 'gemeinsamkeiten', kategorie: 2, titel: 'Gemeinsamkeiten',
    untertitel: ['Familie entdecken · Ab 1 Person', AUCH],
    body: [
      { n: 1, text: 'Zwei Foto-MeMokarten werden gezogen.' },
      { n: 2, text: 'Die Mitspielenden suchen Gemeinsamkeiten zwischen den beiden Personen:' },
      { zb: true },
      { b: 'Beide gehören zum gleichen Familienstamm.' },
      { b: 'Beide haben Kinder.' },
      { b: 'Gleicher Nachname, Geburtsmonat, Haarfarbe, Wohnort, etc.' },
    ],
  },
  {
    nr: 23, key: 'naehe-und-ferne', kategorie: 2, titel: 'Nähe und Ferne',
    untertitel: ['Familie entdecken · Ab 1 Person', AUCH],
    body: [
      { n: 1, text: 'Die Bildkarten werden sortiert nach:' },
      { zb: true },
      { b: 'Wen sehe ich oft?' },
      { b: 'Wen sehe ich manchmal?' },
      { b: 'Wen sehe ich selten?' },
      { b: 'Wen kenne ich noch kaum?' },
      { n: 2, text: 'Wenn man möchte, kann man den Personen anschliessend schreiben oder ein Bild malen.' },
    ],
  },

  // ── Gestalten & Verwenden ────────────────────────────────────────────
  {
    nr: 24, key: 'dekoration', kategorie: 3, titel: 'Dekoration',
    untertitel: ['Gestalten & Verwenden · Ab 1 Person', 'Für die abgebildeten Personen'],
    body: [
      { n: 1, text: 'Schmücke einen Esstisch.' },
      { n: 2, text: 'Nimm die Foto-MeMokarten der bald anwesenden Familienmitglieder.' },
      { gap: true },
      { v: 'Sie dienen als Tischkarten für Sitzplätze am Esstisch bei einer Familienfeier.' },
    ],
  },
  {
    nr: 25, key: 'geburtstagskalender', kategorie: 3, titel: 'Geburtstags-\nkalender',
    untertitel: ['Gestalten & Verwenden · Ab 1 Person', AUCH],
    body: [
      { n: 1, text: 'Nimm die gewünschten MeMo-Karten.' },
      { n: 2, text: 'Kopiere sie für deinen Geburtstagskalender.' },
    ],
  },
];

export const LEGENDE = EXTRA_CARDS.find(c => c.key === 'legende');

// Reihenfolge der Spielideen: abwechselnd aus jeder Kategorie die nächste Karte.
// Ist eine Kategorie leer, kommt gleich die nächste Kategorie dran.
export function spielideenReihenfolge() {
  const queues = KATEGORIEN.map((_, k) => EXTRA_CARDS.filter(c => c.kategorie === k));
  const out = [];
  let any = true;
  while (any) {
    any = false;
    for (const q of queues) {
      if (q.length) { out.push(q.shift()); any = true; }
    }
  }
  return out;
}

/**
 * Plant die Extrakarten für eine Schachtel.
 *  persons      – Anzahl Personen im Stammbaum
 *  capacity     – Anzahl Personen, für die die Schachtel(n) Platz haben
 *  familyColors – Farben der Familienstämme (n = Anzahl)
 * Rückgabe: { freiePlaetze, leerpersonen: [farbe, …], extras: [karte, …], fuellkarten: [farbe, …] }
 *  - jede Leerperson = 2 leere Karten mit Zierrahmen in ihrer Farbe
 *  - jede Extrakarte = 1 Karte
 *  - fuellkarten nur, falls alle Spielideen aufgebraucht sind (in der Praxis nicht erreichbar)
 */
export function planExtras({ persons, capacity, familyColors }) {
  const frei = Math.max(0, capacity - persons);
  const result = { freiePlaetze: frei, leerpersonen: [], extras: [], fuellkarten: [] };
  if (frei === 0) return result;

  const colors = familyColors && familyColors.length ? familyColors : ['#8B8B8B'];
  const n = colors.length;
  let personenPlaetze = frei;

  // Regel 3: ab n+1 freien Plätzen bekommt jede Farbe eine Leerperson
  if (frei >= n + 1) {
    result.leerpersonen = [...colors];
    personenPlaetze -= n;
  }

  // Regel 2: restliche Plätze (je 2 Karten) mit Legende + Spielideen füllen
  let karten = personenPlaetze * 2;
  const reihe = [LEGENDE, ...spielideenReihenfolge()];
  result.extras = reihe.slice(0, karten);
  karten -= result.extras.length;
  for (let i = 0; i < karten; i++) result.fuellkarten.push(colors[i % n]);
  return result;
}
